import { combineReducers } from "redux";
import searchReducer from "../Pages/searchPage/store/reducer";
import wishListReducer from "../Pages/wishListPage/store/reducer";

const rootReducer = (state = {
  baseSettings: {
    searchBaseUrl: "",
    searchApiUrl: "",
    searchPageSlug: "",
    searchPageTitle: "",
    searchFacets: "",
    searchPostType: "",
    searchPerPage: "",
    searchOrder: "",
    searchOrderby: "",
    searchOrderMetaKey: "",
    searchNoResults: "",
    searchLanguage: "",
    searchValue: "",
    heroImageHtml: "",
  },
}, { type, payload }) => {
  switch (type) {
    case "[SYSTEM] BASE API SETTINGS": {
      return {
        ...state,
        baseSettings: payload,
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  rootReducer,
  searchReducer,
  wishListReducer,
});
